export default {
  key: "product",
  basePath: "/product",
  exclude: false,
};
